import { Link } from "react-router-dom";
import { TemperMark } from "./Logo";

const LINKS = [
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/temper-profile", label: "Temper Profile" },
  { to: "/contact", label: "Contact" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-coal text-paper">
      <div className="mx-auto max-w-[1440px] px-6 pb-10 pt-20 md:px-10 md:pt-28">
        <div className="grid gap-14 md:grid-cols-12">
          <div className="md:col-span-7">
            <p className="eyebrow text-ember">Temper Leadership</p>
            <h2 className="mt-6 max-w-xl font-display text-4xl font-extrabold leading-[1.02] tracking-tight md:text-6xl">
              Great leaders aren't born. They're <span className="text-ember">tempered.</span>
            </h2>
            <Link to="/contact" data-testid="footer-cta" className="btn-outline-light mt-10">
              Start the conversation
            </Link>
          </div>
          <div className="md:col-span-5 md:pl-12">
            <div className="flex flex-col gap-4">
              {LINKS.map((l) => (
                <Link
                  key={l.to}
                  to={l.to}
                  data-testid={`footer-${l.label.toLowerCase().replace(" ", "-")}-link`}
                  className="w-fit font-mono text-[11px] uppercase tracking-[0.2em] text-paper/60 transition-colors duration-300 hover:text-ember"
                >
                  {l.label}
                </Link>
              ))}
            </div>
            <div className="mt-8 border-t border-paper/15 pt-6">
              <p className="eyebrow text-paper/40">Reach us</p>
              <a
                href="mailto:eligeikis@gmail.com"
                data-testid="footer-email"
                className="mt-3 block w-fit font-mono text-sm text-paper transition-colors duration-300 hover:text-ember"
              >
                eligeikis@gmail.com
              </a>
            </div>
          </div>
        </div>
        <div className="mt-16 overflow-hidden md:mt-24" aria-hidden="true">
          <div className="select-none font-display text-[24vw] font-black leading-[0.78] text-paper/[0.07] md:text-[17vw]">
            TEMPER
          </div>
        </div>
        <div className="mt-8 flex flex-col gap-3 border-t border-paper/10 pt-6 font-mono text-[10px] uppercase tracking-[0.2em] text-paper/45 md:flex-row md:items-center md:justify-between">
          <span>© {year} Temper Leadership</span>
          <span className="flex items-center gap-2">
            Discipline <TemperMark className="h-3 w-3 text-ember" /> Warmth
          </span>
          <Link to="/admin" data-testid="footer-admin-link" className="transition-colors hover:text-ember">
            Internal
          </Link>
        </div>
      </div>
    </footer>
  );
}
